import { HttpErrorResponse, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { catchError, throwError } from 'rxjs';

import { AUTH_TOKEN, MODULE, REDIRECT_PATH, TENANT } from '@shared/consts';
import { DEFAULT_LANGUAGE } from '@models/system';
import { MsalAuthService } from '@shared/services/auth.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  authService = inject(MsalAuthService);
  private readonly translateService = inject(TranslateService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler) {
    request = request.clone({
      setHeaders: {
        tenantId: request.url.includes('_api/Main/Tenants') ? '' : this.getTenantId(),
        moduleId: this.getModuleId(request.headers),
        // TODO: check why we don't rely on MsalInterceptor
        Authorization: `Bearer ${this.getToken()}`,
        'X-CIPO-Language': this.translateService.getCurrentLang() || DEFAULT_LANGUAGE,
      },
    });
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // only fail for our APIs
        if (error.status === 401 && request.url.startsWith(environment.baseApiUrl)) {
          localStorage.setItem(REDIRECT_PATH, window.location.href);
          this.authService.logout(true);
        }
        return throwError(() => error);
      }),
    );
  }

  private getToken(): string {
    return localStorage.getItem(AUTH_TOKEN) || '';
  }

  private getTenantId(): string {
    return sessionStorage.getItem(TENANT) || '';
  }

  private getModuleId(headers: HttpHeaders): string {
    if (headers.has('moduleId')) {
      return headers.get('moduleId');
    }
    return sessionStorage.getItem(MODULE) || '';
  }
}
